import { EmptyState, ErrorNote, Spinner, StatusChip } from '../ui/primitives.js';
import type { MeetingListItem } from '@kima-hub/contracts';
import { COPY } from '../copy.js';
import { Link, paths } from '../router.js';
import { useServices } from '../services.js';
import { formatDate, recordingUnavailableText } from '../ui/labels.js';
import { usePaged } from './usePaged.js';

export function RecentMeetings() {
  const { api } = useServices();
  const list = usePaged<MeetingListItem>('recent', (cursor, signal) => api.meetings({ cursor }, signal));

  return (
    <section aria-labelledby="recent-title">
      <h2 id="recent-title">{COPY.recentMeetings}</h2>
      {list.items.length === 0 && !list.loading && !list.error && <EmptyState title={COPY.noMeetings} />}
      <ul className="list" data-testid="recent-meetings">
        {list.items.map((m) => {
          const noRecording = recordingUnavailableText(m.recording);
          return (
            <li key={m.id}>
              <Link href={paths.meeting(m.id)}>
                {m.room ? `${m.room.title} \u00b7 ` : ''}
                {formatDate(m.started_at)}
              </Link>{' '}
              <span className="muted">
                <StatusChip status={m.status} />
                {m.participants.length > 0 && ` \u00b7 ${m.participants.map((p) => p.display_name).join(', ')}`}
              </span>
              {noRecording && <span className="notice"> &#183; {noRecording}</span>}
            </li>
          );
        })}
      </ul>
      {list.loading && <div className="loading"><Spinner /><span>{COPY.loading}</span></div>}
      {list.error && <ErrorNote message={list.error} />}
      {list.hasMore && !list.loading && (
        <button type="button" onClick={list.loadMore}>
          {COPY.loadMore}
        </button>
      )}
    </section>
  );
}
